import dayjs from "dayjs";

import { simulateMockDelay } from "src-next/modules/crm-clinical/shared/mockAsync";

import type { QuestionnaireSummary } from "../types";

const STORAGE_KEY = "crm.questionnaires.v1";

const DEFAULT_QUESTIONNAIRES: QuestionnaireSummary[] = [
  {
    id: "questionnaire-1",
    title: "Triagem rápida",
    description:
      "Perguntas iniciais para entender o motivo da consulta e sinais de alerta.",
    updatedAtIso: dayjs().subtract(4, "day").toISOString(),
  },
  {
    id: "questionnaire-2",
    title: "Pré-consulta (história clínica)",
    description:
      "Coleta de sintomas, medicações em uso e histórico relevante antes do atendimento.",
    updatedAtIso: dayjs().subtract(2, "day").toISOString(),
  },
];

function readQuestionnaires(): QuestionnaireSummary[] {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return DEFAULT_QUESTIONNAIRES;

  try {
    const parsed = JSON.parse(raw) as QuestionnaireSummary[];
    if (!Array.isArray(parsed)) return DEFAULT_QUESTIONNAIRES;
    return parsed;
  } catch {
    return DEFAULT_QUESTIONNAIRES;
  }
}

async function list(): Promise<QuestionnaireSummary[]> {
  await simulateMockDelay({ ms: 300 });
  return readQuestionnaires();
}

export const questionnairesService = {
  list,
};
